<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title>
          Configuración de Parámetros del Sistema
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar parámetro"
            single-line
            hide-details
          />
        </v-card-title>
        <v-card-text>
          <v-expansion-panels
            v-model="panel"
            multiple
            class="mb-4"
          >
            <v-expansion-panel
              v-for="(grupo, index) in gruposAgrupados"
              :key="index"
              class="mb-3 elevation-2"
            >
              <v-expansion-panel-header class="pa-4">
                <div class="d-flex align-center">
                  <v-avatar
                    :color="getColorGrupo(grupo.nombre)"
                    size="40"
                    class="mr-3"
                  >
                    <v-icon
                      dark
                      size="24"
                    >
                      {{ getIconGrupo(grupo.nombre) }}
                    </v-icon>
                  </v-avatar>
                  <div>
                    <div class="text-h6 font-weight-medium">
                      {{ grupo.nombre }}
                    </div>
                    <div class="text-caption grey--text">
                      {{ grupo.total }} parámetros • {{ grupo.editables }} editables
                    </div>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-4">
                <v-data-table
                  :headers="tableHeaders"
                  :items="getParametrosByGrupo(grupo.nombre)"
                  hide-default-footer
                  disable-pagination
                  class="elevation-0"
                >
                  <template v-slot:[`item.parametro`]="{ item }">
                    <div>
                      <div class="font-weight-medium mb-1 mt-2">
                        {{ item.name }}
                      </div>
                      <div class="text-caption grey--text text--darken-1 mb-2">
                        {{ item.description }}
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.valor`]="{ item }">
                    <span class="font-weight-medium">
                      {{ item.value }} {{ item.UnidadInfo.simbolo || '' }}
                    </span>
                  </template>

                  <template v-slot:[`item.estado`]="{ item }">
                    <div class="d-flex align-center justify-center">
                      <v-icon
                        :color="item.editable === 1 ? 'success' : 'error'"
                        small
                        class="mr-1"
                      >
                        {{ item.editable === 1 ? 'mdi-check-circle' : 'mdi-lock' }}
                      </v-icon>
                      <span class="text-caption">
                        {{ item.editable === 1 ? 'Editable' : 'Solo lectura' }}
                      </span>
                    </div>
                  </template>

                  <template v-slot:[`item.acciones`]="{ item }">
                    <v-btn
                      v-if="item.editable === 1"
                      color="primary"
                      small
                      icon
                      @click="editarParametro(item)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <span
                      v-else
                      class="grey--text text-caption"
                    >-</span>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </base-card>
    </v-col>

    <!-- Dialog para editar -->
    <v-dialog
      v-model="dialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-actions class="justify-end">
          <v-icon
            text
            @click="handleClose"
          >
            mdi-close-thick
          </v-icon>
        </v-card-actions>
        <v-toolbar
          style="background-color:rgb(204 33 40);color:white !important"
          dark
        >
          <strong>Editar Parámetro</strong> - {{ editedItem.name }}
        </v-toolbar>
        <v-card-text style="padding-top: 20px;">
          <v-form ref="formEditParametro">
            <v-row>
              <v-col cols="12">
                <v-chip
                  :color="getColorGrupo(editedItem.group)"
                  class="mb-2"
                  text-color="white"
                  small
                >
                  <v-icon
                    left
                    small
                  >
                    {{ getIconGrupo(editedItem.group) }}
                  </v-icon>
                  {{ editedItem.group }}
                </v-chip>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.name"
                  label="Nombre"
                  prepend-inner-icon="mdi-tag"
                  disabled
                  readonly
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.description"
                  label="Descripción"
                  prepend-inner-icon="mdi-information"
                  disabled
                  readonly
                  rows="2"
                  auto-grow
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.value"
                  :label="getValorLabel()"
                  :type="getInputType()"
                  :step="getInputStep()"
                  :rules="getInputRules()"
                  clearable
                  required
                  autofocus
                />
              </v-col>
            </v-row>
            <v-row v-if="msgResponse">
              <v-col cols="12">
                <v-alert
                  :type="alertType"
                  text
                >
                  {{ msgResponse }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row
              v-if="progress"
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col cols="6">
                <v-col
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  Actualizando Parámetro
                </v-col>
                <v-progress-linear
                  color="red darken-4"
                  indeterminate
                  rounded
                  height="6"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="handleClose"
          >
            Cancelar
          </v-btn>
          <v-btn
            text
            style="background-color:rgb(204 33 40);color:white !important"
            @click="guardarParametro"
          >
            Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'ShowParametros',
  data () {
    return {
      search: '',
      panel: [0, 1, 2, 3], // Abrir todos los paneles por defecto
      dialog: false,
      editedItem: {},
      msgResponse: '',
      progress: false,
      alertType: 'success',
      tableHeaders: [
        { text: 'Parámetro', value: 'parametro', sortable: false, width: '40%' },
        { text: 'Valor Actual', value: 'valor', align: 'center', sortable: false, width: '20%' },
        { text: 'Estado', value: 'estado', align: 'center', sortable: false, width: '25%' },
        { text: 'Acciones', value: 'acciones', align: 'center', sortable: false, width: '15%' },
      ],
    }
  },

  computed: {
    parametros () {
      return this.$store.state.parametros.listParametros
    },
    gruposAgrupados () {
      return this.$store.getters['parametros/gruposAgrupados']
    },
    parametrosFiltrados () {
      if (!this.search) return this.parametros
      const searchLower = this.search.toLowerCase()
      return this.parametros.filter(p =>
        p.name.toLowerCase().includes(searchLower) ||
        p.group.toLowerCase().includes(searchLower),
      )
    },
  },

  created () {
    this.getListParametros()
  },

  methods: {
    async getListParametros () {
      await this.$store.dispatch('parametros/getListParametros')
    },

    getParametrosByGrupo (grupo) {
      const params = this.search ? this.parametrosFiltrados : this.parametros
      return params.filter(p => p.group === grupo)
    },

    editarParametro (item) {
      this.editedItem = { ...item }
      this.msgResponse = ''
      this.progress = false
      this.alertType = 'success'
      this.dialog = true
    },

    handleClose () {
      this.msgResponse = ''
      this.progress = false
      this.alertType = 'success'
      this.dialog = false
      if (this.$refs.formEditParametro) {
        this.$refs.formEditParametro.reset()
      }
    },

    getValorLabel () {
      if (this.editedItem.UnidadInfo && this.editedItem.UnidadInfo.simbolo) {
        return `Valor (${this.editedItem.UnidadInfo.simbolo})`
      }
      return 'Valor'
    },

    async guardarParametro () {
      // Validar el formulario
      if (!this.$refs.formEditParametro.validate()) {
        return
      }

      this.progress = true
      this.msgResponse = ''
      this.alertType = 'success'

      try {
        const payload = {
          id: this.editedItem.id,
          valor: this.editedItem.value,
        }

        await this.$store.dispatch('parametros/updateParametro', payload)

        if (this.$store.state.parametros.updateStatusResponse) {
          this.progress = false
          this.alertType = 'success'
          this.msgResponse = 'Parámetro actualizado correctamente'

          setTimeout(async () => {
            await this.getListParametros()
            this.handleClose()
            this.$store.dispatch('parametros/resetUpdateResponse')
          }, 2000)
        } else {
          this.progress = false
          this.alertType = 'error'
          this.msgResponse = 'Error al actualizar parámetro. Por favor intente nuevamente'
        }
      } catch (error) {
        this.progress = false
        this.alertType = 'error'
        this.msgResponse = error.message || 'Error al actualizar el parámetro'
        console.error(error)
      }
    },

    detectarTipoDato () {
      if (!this.editedItem || !this.editedItem.value) return 'text'

      const valor = String(this.editedItem.value).trim()

      // Si tiene unidad, probablemente es numérico
      if (this.editedItem.UnidadInfo && this.editedItem.UnidadInfo.simbolo) {
        const unidadesNumericas = ['%', 'días', 'día', 'registros']
        const simbolo = this.editedItem.UnidadInfo.simbolo.toLowerCase()

        if (unidadesNumericas.some(u => simbolo.includes(u))) {
          // Detectar si el valor actual tiene decimales
          return (valor.includes('.') || valor.includes(',')) ? 'decimal' : 'number'
        }
      }

      // Intentar parsear como número
      const valorNumerico = valor.replace(',', '.')
      const num = Number(valorNumerico)

      if (!isNaN(num) && valor !== '') {
        // Es un número válido
        return Number.isInteger(num) && !valorNumerico.includes('.') ? 'number' : 'decimal'
      }

      // Detectar booleanos
      const valorLower = valor.toLowerCase()
      if (['true', 'false', 'verdadero', 'falso', 'si', 'no'].includes(valorLower)) {
        return 'boolean'
      }

      // Por defecto es texto
      return 'text'
    },

    getInputType () {
      const tipo = this.detectarTipoDato()

      if (tipo === 'number' || tipo === 'decimal') {
        return 'number'
      }

      return 'text'
    },

    getInputStep () {
      const tipo = this.detectarTipoDato()

      if (tipo === 'decimal') {
        return '0.01'
      } else if (tipo === 'number') {
        return '1'
      }

      return 'any'
    },

    getInputRules () {
      const tipo = this.detectarTipoDato()
      const rules = [
        v => !!v || 'Este campo es requerido',
      ]

      if (tipo === 'number') {
        rules.push(v => {
          const num = Number(v)
          return Number.isInteger(num) || 'Debe ser un número entero'
        })
        rules.push(v => {
          const num = Number(v)
          return num >= 0 || 'Debe ser un número positivo'
        })
      }

      if (tipo === 'decimal') {
        rules.push(v => {
          const num = Number(v)
          return !isNaN(num) || 'Debe ser un número válido'
        })
        rules.push(v => {
          const num = Number(v)
          return num >= 0 || 'Debe ser un número positivo'
        })
      }

      if (tipo === 'boolean') {
        rules.push(v => {
          const lower = String(v).toLowerCase()
          return ['true', 'false', '1', '0', 'si', 'no', 'verdadero', 'falso'].includes(lower) || 'Debe ser true/false, si/no o 1/0'
        })
      }

      return rules
    },

    getColorGrupo (nombre) {
      const colores = {
        'Procesamiento': 'blue',
        'TEF': 'green',
        'Sistema': 'orange',
        'Facturación': 'green',
      }
      return colores[nombre] || 'grey'
    },

    getIconGrupo (nombre) {
      const iconos = {
        'Procesamiento': 'mdi-cog-sync',
        'TEF': 'mdi-credit-card',
        'Sistema': 'mdi-server',
        'Facturación': 'mdi-receipt',
      }
      return iconos[nombre] || 'mdi-folder'
    },
  },
}
</script>
